import React from 'react';
import { Spin } from 'antd';
import { useGetUser } from 'query/admin';

export default function DisplayUserEmail({ id }) {
  const { data, isLoading } = useGetUser(id);
  return (
    <div style={{ display: 'inline-block' }}>
      <Spin spinning={isLoading}>{data?.email || id}</Spin>
    </div>
  );
}
